import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=1aa9824a&scoped=true&"
import script from "./Opportunities.vue?vue&type=script&lang=js&"
export * from "./Opportunities.vue?vue&type=script&lang=js&"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=1aa9824a&prod&lang=css&"
import style1 from "./Opportunities.vue?vue&type=style&index=1&id=1aa9824a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9824a",
  null
  
)

export default component.exports